import { makeDynamicDataLoader } from './factory';

export const { get: getMsaAliasToId, load: loadMsaAliasToId } = makeDynamicDataLoader('msas', (set, client) =>
  client.msas
    .getList({ include_all: 1 })
    .then(({ msas }) => set(msas.reduce((acc, msa) => ({ ...acc, [msa.alias]: msa.id }), {})))
);
